import { createReducer } from '@reduxjs/toolkit';
import { initializeAxios } from '../actions/axios';

export default createReducer(false, (builder) => {
  builder.addCase(initializeAxios, () => true)
});
